import { ForwardedRef, forwardRef } from "react";

// Custom styles for MDTypography
import MDTypographyRoot from "../MDTypography/MDTypographyRoot";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "../../../../Context";
import { BaseProps } from "@mui/material/OverridableComponent";

export const MDTypography = forwardRef(
  (
    {
      color = "dark",
      fontWeight = false,
      textTransform = "none",
      verticalAlign = "unset",
      textGradient = false,
      opacity = 1,
      children,
      backgroundColour = '',
      ...rest
    }: BaseProps<any>,
    ref: ForwardedRef<any>
  ) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller as any;

    return (
      <MDTypographyRoot
        {...rest}
        ref={ref}
        ownerState={{
          backgroundColour,
          color,
          textTransform,
          verticalAlign,
          fontWeight,
          opacity,
          textGradient,
          darkMode,
        }}
      >
        {children}
      </MDTypographyRoot>
    );
  }
);
